"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMontageSet9 = exports.montageSet9UseableDef = void 0;
const ArticleBase_1 = require("../../ArticleBase");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.montageSet9UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.montageSet,
    },
};
exports.isMontageSet9 = echain_shared_modelling_1.UseableUtil.createGuard(exports.montageSet9UseableDef);
//# sourceMappingURL=MontageSet9.js.map